import { createSlice } from '@reduxjs/toolkit'
import { PERMISSION_STATES } from '../../../../utils/permissions-service'

const initialState = {
  newPermission: PERMISSION_STATES.PROMPT,
  positionErrorMsg: '',
  geoPosition: {},
  position: {
    lat: null,
    lng: null
  }
}

export const geolocationSlice = createSlice({
  name: 'geolocation',
  initialState,
  reducers: {
    updateGeolocation: (state, action) => {
      const {
        newPermission,
        positionErrorMsg,
        geoPosition,
        position
      } = action.payload

      state.geoPosition = geoPosition
      state.position = position
      state.newPermission = newPermission
      state.positionErrorMsg = positionErrorMsg
    },

    // Use when GPS fails transiently (timeout, unavailable) — keeps existing position intact
    updateGeolocationError: (state, action) => {
      const { positionErrorMsg } = action.payload
      state.positionErrorMsg = positionErrorMsg
    },

    // Full reset including permission. Dispatched on delivery mount so a
    // second delivery starts from a clean state even if the first left a
    // persisted/permanent DENIED.
    resetGeolocation: () => initialState
  }
})

export const { updateGeolocation, updateGeolocationError, resetGeolocation } = geolocationSlice.actions

export const selectGeolocation = (state) => state.geolocation

export default geolocationSlice.reducer
